
const Backbone = require('backbone');
const Nunjuks = require('view');
const template = require('./index.twig');

const ViewCardapioAtual = require('./tr-cardapio-atual');
const ViewLiFiltros = require('./li-filtros');
const ViewTrProduto = require('./tr-produto');

const Filtros = require('../../../collections/filtros');
const Produtos = require('../../../collections/produtos');

var View = Backbone.View.extend({
	initialize: function(config) {
		var that = this;

		that.kit = config.model;
		that.porcoes = config.collection;

		that.Busca = new Backbone.Model({
			busca: '',
			filtros: []
		});

		that.CardapioAtual = new Backbone.Collection(that.porcoes.toJSON());

		that.Produtos = new Backbone.Collection();			


		that.listenTo(that.CardapioAtual,'add', that.addCardapioAtual);
		that.listenTo(that.Produtos,'add', that.addProduto);			

		that.listenTo(Filtros, 'add', that.addFiltro);
		that.listenTo(Produtos, 'add remove change', that.setProdutos);
		that.listenTo(that.Busca, 'change', that.setProdutos);


		that.render();

		that.setProdutos();
	},
	events: {
		'click .btn-buscar': 'buscar',
		'click .btn-salvar': 'salvar'
	},
	salvar: function() {
		var that = this;
		var porcoes = that.CardapioAtual.toJSON();

		that.porcoes.set(porcoes);
		window.setTimeout(function(){
			jQuery(that.el).dialog('close');
		},300);
	},
	buscar: function() {
		var that = this;
		var busca = $.trim(that.$form.find('[name=busca]').val());
		busca = busca.replace(/\s+/igm,' ');
		var filtros = that.$form.find(':checkbox:checked').toArray().map(function(el){
			return $(el).val()|0;
		});
		that.Busca.set({
			busca: busca,
			filtros: filtros
		});
	},
	setProdutos: function() {
		var that = this;

		var busca = that.Busca.get('busca');
		var filtros = that.Busca.get('filtros');

		var produtos = Produtos.toArray();

		if (busca != '') {
			var keywords = busca.split(/\s+/igm);
			keywords.forEach(function(keyword){
				produtos = produtos.filter(function(produto){
					var regexp = new RegExp(keyword,'igm');					
					return regexp.test(produto.get('titulo'));
				});
			});
		}


		if (filtros.length != 0) {
			filtros.forEach(function(filtro_id) {
				produtos = produtos.filter(function(produto){
					var f = produto.get('filtros').map(function(filtro){
						return filtro.id;
					});
					if (-1 === f.indexOf(filtro_id)) return false;
					return true;
				});
			});
		}




		that.Produtos.set(produtos);

	},
	addProduto: function(model) {
		var that = this;
		if (that.$tableProdutos === undefined) return;
		var view = new ViewTrProduto({
			model: model,
			porcoes: that.porcoes,
			kit: that.kit,
			CardapioAtual: that.CardapioAtual
		});
		that.$tableProdutos.append(view.$el);
	},
	addFiltro: function(model) {
		var that = this;

		var view = new ViewLiFiltros({
			model: model
		});

		that.$ulFiltros.append(view.$el);

	},
	addCardapioAtual: function(model) {
		var that = this;
		var view = new ViewCardapioAtual({
			model: model,
			CardapioAtual: that.CardapioAtual
		});
		that.$tableCardapioAtual.append(view.$el);
	},
	render: function() {
		var that = this;
		var data = {		
			porcoes: that.porcoes.toJSON()
		};

		var html = Nunjuks.renderString(template, data);
		that.$el.html(html);

		that.$tableCardapioAtual = that.$el.find('.table-cardapio-atual');
		that.$ulFiltros = that.$el.find('.ul-filtros');
		that.$tableProdutos = that.$el.find('.table-produtos tbody');
		that.$form = that.$el.find('form');

		that.CardapioAtual.each(function(model) {
			that.addCardapioAtual(model);
		});

		that.Produtos.each(function(model) {
			that.addProduto(model);
		});

		Filtros.each(function(model) {					
			that.addFiltro(model);
		});
		$(window).trigger('resize');
		

	}
});


module.exports = View;


//////////////////
// WEBPACK FOOTER
// ./views/kits/dialog-cardapio/index.js
// module id = 40
// module chunks = 0